import i18n from "../i18n";
import resources from "../locales";
import { appStore } from "../store/store";

import "./chatwootService.css";

interface ChatwootSDK {
  run(options: { websiteToken: string; baseUrl: string }): void;
}

interface ChatwootInstance {
  setConversationCustomAttributes(attrs: Record<string, unknown>): void;
}

interface ChatwootSettings {
  type: "expanded_bubble";
  locale: string;
  launcherTitle: string;
  welcomeTitle: string;
  welcomeDescription: string;
  availableMessage: string;
  unavailableMessage: string;
  enableEndConversation: false;
}

declare global {
  interface Window {
    $chatwoot?: ChatwootInstance;
    chatwootSDK?: ChatwootSDK;
    chatwootSettings?: ChatwootSettings;
  }
}

export const syncChatwootCurrentPage = (): void => {
  window.$chatwoot?.setConversationCustomAttributes({
    current_page: window.location.href,
  });
};

export const initChatwoot = (locale: string): void => {
  const config = appStore.config.chatwoot;
  if (!config) return;
  const chatwootUrl = new URL(config.base_url);

  const lang = locale in resources ? locale : "en";
  const t = i18n.getFixedT(lang);

  const script = document.createElement("script");
  script.src = new URL("packs/js/sdk.js", chatwootUrl).href;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    window.chatwootSettings = {
      type: "expanded_bubble",
      locale,
      launcherTitle: t("chatwoot.launcherTitle"),
      welcomeTitle: t("chatwoot.welcomeTitle"),
      welcomeDescription: t("chatwoot.welcomeDescription"),
      availableMessage: t("chatwoot.availableMessage"),
      unavailableMessage: t("chatwoot.unavailableMessage"),
      enableEndConversation: false,
    };
    window.addEventListener("chatwoot:ready", syncChatwootCurrentPage, {
      once: true,
    });
    window.chatwootSDK?.run({
      websiteToken: config.website_token,
      baseUrl: chatwootUrl.origin,
    });
  };
  document.head.appendChild(script);
};
